{ currentModelManager } = require 'app/scripts/controller/currentModelManager'
FileLinkHandler = require 'app/scripts/views/internal/file-link-handler'
isWebClientPage = require 'app/scripts/lib/util/url/is-web-client-page'
Layout = require 'app/scripts/views/lib/layout'
ModelCache = require 'app/scripts/db/model-cache'
shouldHandleClick = require 'app/scripts/lib/util/should-handle-click'
SidebarState = require 'app/scripts/view-models/sidebar-state'
Util = require 'app/scripts/lib/util'
PopOver = require 'app/scripts/views/lib/pop-over'
$ = require 'jquery'
{ Noun, Verb, trackUe } = require '@trello/analytics'
{ siteDomain } = require '@trello/config'
{ navigate } = require 'app/scripts/controller/navigate'

handleLinkClick = (e) ->
  $a = $(e.target).closest('a')
  href = $a.attr('href')
  if !href || href == '#'
    Util.preventDefault(e)
  else if href.indexOf('file://') == 0
    Util.preventDefault(e)
    FileLinkHandler($a[0])
  else if href.indexOf('/') == 0 || href.indexOf(siteDomain + '/') == 0
    urlTarget = href
      .replace(/// ^ #{ siteDomain } ///, '')
      .replace(/// ^ /(?=.) ///, '')

    # location.pathname has a leading "/"; urlTarget does not
    isNewUrl = urlTarget != location.pathname.slice(1)

    if window != window.top && navigatesOffBoard(urlTarget)
      Util.preventDefault(e)
      window.open(urlTarget)
      return

    # If the page is just a virtual route served by the controller, we don't
    # need to reload the page. Unless it has target="_blank", because when
    # you "attach" a Trello card to another card you get an "open in a new
    # tab" link that we don't want to intercept.
    if isWebClientPage(href) && !$a.attr('target')?
      Util.preventDefault(e)
      if isNewUrl
        navigate(urlTarget, { trigger: true })

  return

# In cases where we're framed, we want to intercept navigation to other parts
# of Trello, and open those in new windows
navigatesOffBoard = (urlTarget) ->
  if (currentBoard = currentModelManager.getCurrentBoard())?
    # If we're not a relative URL for a card or board, then we can't be on
    # the same board
    parts = ///^([bc])/([^/]+)///.exec(urlTarget)
    if !parts?
      return true

    [all, modelLetter, shortLink] = parts

    switch modelLetter
      when 'b'
        shortLink != currentBoard.get('shortLink')
      when 'c'
        ModelCache.get('Card', shortLink)?.getBoard() != currentBoard
      else
        true
  else
    # If we're not on a board right now, don't worry about navigating
    # off of it
    false

module.exports = (e) ->
  $target = $(e.target)

  # This does a blanket selections for any classic fields using
  # 'editable-view.coffee' that are currently editing (as well as some other
  # selectors). We should aim to move this logic closer to the components that
  # need it (or into the editable-view).
  #
  # The giant if/else-if statement that used to live here would implicitly
  # ignore the Layout.isEditing() check for any clicks inside popovers. Removing
  # this check today causes any popovers that use the selectors checked for in
  # Layout.isEditing() to break (an example of this is the custom fields popover
  # that allows you to customize the options in a 'dropdown' custom field, where
  # you can no longer change the name of the option due to it being immediately
  # canceled without this check).
  #
  # Removal tracked in: FEPLAT-505
  clickInPopover = PopOver.isVisible && $target.closest('.pop-over').length > 0

  if !clickInPopover && Layout.isEditing()
    Layout.cancelEdits()

  $a = $target.closest('a')
  # If it's not a link or they're trying to do some fancy click (that opens in
  # a new tab, etc) don't try to subvert it
  if $a.length && shouldHandleClick(e)
    handleLinkClick(e)

  return
